import React, { useEffect, useState } from 'react';
import { getData } from '../../../../utils/api';
import { getApi } from '../../../../utils/getApi';
import Qrimg from '../../../../static/img/d53147c20q824284625cf09361070f261077685171.jpg'; // 二维码图片
import bgImg from '../../../../static/img/xlcx2022.jpg'; // 请将您的背景图文件放在当前目录或引入对应路径
import "./index.css";


export const Xuelidown = () => {
  const [list, setList] = useState({});
    const [path, setPath] = useState('');
  useEffect(() => {
	  setPath(getApi())
    const onlineCode = window.location.search.split('?id=')[1];
    if (onlineCode) {
      getYanzeng(onlineCode);
    } else {
      getList();
    }
  }, []);
	const xl_type = window.localStorage.getItem('type')
	const status_type = window.localStorage.getItem('status')
  const getList = async () => {
    const res = await getData('/api/user/zhengshu', 'post');
    if (res?.data?.code === 1) {
		
		console.log('类型',xl_type)
		console.log('第几学历',status_type)
		if(status_type == 'twoxj') {
			res.data.data[0].enrollment_time = res.data.data[0].sec_enrollment_time
			res.data.data[0].graduation_time = res.data.data[0].sec_graduation_time
			res.data.data[0].school_name = res.data.data[0].sec_school_name
			res.data.data[0].zhuanye = res.data.data[0].sec_zhuanye
			res.data.data[0].xuezhi = res.data.data[0].sec_xuezhi
			res.data.data[0].xueli_level = res.data.data[0].sec_xueli_level
			res.data.data[0].leibie = res.data.data[0].sec_leibie
			res.data.data[0].xingshi = res.data.data[0].sec_xingshi
			res.data.data[0].is_biye = res.data.data[0].sec_is_biye
			res.data.data[0].certificate_number = res.data.data[0].sec_certificate_number
			res.data.data[0].rector = res.data.data[0].sec_rector
			res.data.data[0].online_code = res.data.data[0].sec_online_code
		} else if( status_type && status_type=='threexj') {
			res.data.data[0].enrollment_time = res.data.data[0].thr_enrollment_time
			res.data.data[0].graduation_time = res.data.data[0].thr_graduation_time
			res.data.data[0].school_name = res.data.data[0].thr_school_name
			res.data.data[0].zhuanye = res.data.data[0].thr_zhuanye
			res.data.data[0].xuezhi = res.data.data[0].thr_xuezhi
			res.data.data[0].xueli_level = res.data.data[0].thr_xueli_level
			res.data.data[0].leibie = res.data.data[0].thr_leibie
			res.data.data[0].xingshi = res.data.data[0].thr_xingshi
			res.data.data[0].is_biye = res.data.data[0].thr_is_biye
			res.data.data[0].certificate_number = res.data.data[0].thr_certificate_number
			res.data.data[0].rector = res.data.data[0].thr_rector
			res.data.data[0].online_code = res.data.data[0].thr_online_code
			
		}
      setList(res.data.data[0] || {});
    }
  };

  const getYanzeng = async (onlineCode) => {
    const res = await getData('/api/user/yanzheng', 'post', { online_code: onlineCode });
    if (res?.data?.code === 1) {
      setList(res.data.data[0] || {});
    }
  };

  const formatDateString = (dateStr) => {
    if (dateStr == null) return dateStr;
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return dateStr.replace(/(\d{4})-(\d{2})-(\d{2})/, '$1年$2月$3日');
    }
    return dateStr;
  };

  const times = (v) => {
    if (!v) return '';
    let timestamp;

    if (typeof v === 'number' || /^\d+$/.test(v)) {
      const numValue = Number(v);
      timestamp = numValue < 10000000000 ? numValue * 1000 : numValue;
    } else if (typeof v === 'string' && v.includes('年') && v.includes('月') && v.includes('日')) {
      const match = v.match(/(\d{4})年(\d{1,2})月(\d{1,2})日/);
      if (match) {
        const [, year, month, day] = match;
        return `${year}年${month.padStart(2, '0')}月${day.padStart(2, '0')}日`;
      }
      timestamp = new Date(v).getTime();
    } else if (typeof v === 'string') {
      timestamp = new Date(v).getTime();
      if (isNaN(timestamp)) {
        const cleanedStr = v.replace(/\//g, '-');
        timestamp = new Date(cleanedStr).getTime();
      }
    } else {
      timestamp = new Date(v).getTime();
    }

    if (isNaN(timestamp)) return '';

    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}年${month}月${day}日`;
  };

  const renderGender = (gender) => {
    if (gender === 0) return '女';
    if (gender === 1) return '男';
    return gender || '';
  };

  return (
    <div className="chsi-page-wrapper">
      <div 
        className="chsi-card-container"
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <div className="chsi-card-inner">
			{xl_type=='xj'?
          <h1 className="chsi-title">教育部学籍证书电子注册备案表</h1>
		  : <></>
		  }
		  {xl_type=='xl'?
          <h1 className="chsi-title">教育部学历证书电子注册备案表</h1>
		  : <></>
		  }
		  {xl_type=='xw'?
          <h1 className="chsi-title">教育部学位证书电子注册备案表</h1>
		  : <></>
		  }
          <div className="chsi-update-date">更新日期：{times(list.updatetime)}</div>

          {/* 表单与头像区 */}
          <div className="chsi-info-section">
            <div className="chsi-avatar-wrapper">
              {list.avatar || list.luqu_avatar ? (
                <img 
                  src={`${path}${list.is_biye === 1 ? list.avatar : list.luqu_avatar}`} 
                  alt="头像" 
                  className="chsi-avatar-img" 
                />
              ) : null}
            </div>

            <div className="chsi-info-row">
              <span className="chsi-label">姓名</span>
              <span className="chsi-value">{list.username}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">性别</span>
              <span className="chsi-value">{renderGender(list.gender)}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">出生日期</span>
              <span className="chsi-value">{formatDateString(list.birthday)}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">入学日期</span>
              <span className="chsi-value">{formatDateString(list.enrollment_time)}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">毕（结）业日期</span>
              <span className="chsi-value">{formatDateString(list.graduation_time)}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">学校名称</span>
              <span className="chsi-value">{list.school_name}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">专业</span>
              <span className="chsi-value">{list.zhuanye}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">学制</span>
              <span className="chsi-value">{list.xuezhi}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">层次</span>
              <span className="chsi-value">{list.xueli_level}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">学历类别</span>
              <span className="chsi-value">{list.leibie}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">学习形式</span>
              <span className="chsi-value">{list.xingshi}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">毕（结）业</span>
              <span className="chsi-value">{list.is_biye === 1 ? '结业' : '毕业'}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">证书编号</span>
              <span className="chsi-value">{list.certificate_number}</span>
            </div>
            <div className="chsi-info-row">
              <span className="chsi-label">校（院）长姓名</span>
              <span className="chsi-value">{list.rector}</span>
            </div>
          </div>

          {/* 在线验证二维码框 */}
          <div className="chsi-verify-box">
            <div className="chsi-qr-code">
              <img src={Qrimg} alt="二维码" />
            </div>
            <div className="chsi-verify-text">
              <div className="chsi-code-row">
                <span className="chsi-code-title">在线验证码</span>
                <span className="chsi-code-num">{list.online_code}</span>
              </div>
              <div className="chsi-verify-url">①验证报告在线查验网址：https://www.chsi.com.cn/xlcx/bgcx.jsp</div>
              <div className="chsi-verify-tip">②使用学信网App扫描二维码验证</div>
            </div>
          </div>

          {/* 底部注意事项 */}
          <div className="chsi-footer">
            <div className="chsi-notice-title">注意事项：</div>
            <div className="chsi-notice-list">
              <p>1、备案表是依据《高等学校学生学籍学历电子注册办法》（<span className="chsi-link">教学[2014]11号</span>）对学历证书电子注册复核备案的结果。</p>
              <p>2、备案表内容如有修改，请以最新在线验证的内容为准。</p>
              <p>3、未经学历信息权属人同意，不得将备案表用于违背权属人意愿之用途。</p>
              <p>4、报告在线验证有效期由报告权属人设置（1~6个月），其在报告验证到期前可再次延长验证有效期。</p>
            </div>
            
            <div className="chsi-bottom-logo">
              <img src="https://t1.chei.com.cn/chsi/images/logo.png" alt="CHSI Logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Xuelidown;
